var RatingFilterType = {
    Datagraph: "Datagraph",
    EPS: "EPS",
    RelativeStrength: "RelativeStrength",
    AccumulationDistribution: "AccumulationDistribution"
}
export default RatingFilterType;